const loadStyle = (href) => {
  let timer;

  const checkIfExist = (url) => {
    for (let i = 0; i < document.styleSheets.length; i += 1) {
      if (document.styleSheets[i].href === url) {
        return true;
      }
    }
    return false;
  };

  return new Promise((resolve, reject) => {
    const ifExist = checkIfExist(href);
    if (ifExist) reject();
    const sheet = document.createElement('link');
    sheet.rel = 'stylesheet';
    sheet.href = href;
    sheet.type = 'text/css';
    document.head.appendChild(sheet);

    sheet.onload = resolve;
    sheet.addEventListener('load', resolve);
    sheet.onreadystatechange = () => {
      if (sheet.readyState === 'loaded' || sheet.readyState === 'complete') {
        resolve();
      }
    };

    timer = setInterval(() => {
      const isAdded = checkIfExist(href);
      if (isAdded) resolve();
    }, 250);
  }).then(() => {
    clearInterval(timer);
    return null;
  });
};

export default loadStyle;
